import React, { useEffect, useState } from "react";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import { useFormik } from "formik";
import * as yup from "yup";
import { SettingHeading } from "../../../../Components/Utils/Settingheading";
import { NuInput, NuMobileNumber } from "../../../../Components/Utils/Input";
import CustomImgUpload from "../../../../Components/Utils/CustomImgUpload";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import { useLocation, useParams } from "react-router-dom";
import useEditFormData from "../../../../Components/Hooks/useEditFormData";
import axiosInstance from "../../../../Services/axiosCommon";
import UseCustomerDropDownNew from "../../../../Components/Hooks/useCustomerSearch";
import { useToast } from "../../../../Components/Others/ToastServices";

function EditUser() {
  const location = useLocation();
  const { editUserId } = useParams();
  const from = location.state?.from;
  const toast = useToast();
  const { Oncancel, editFormData, contextHolder, isLoading } = useEditFormData();

  const [roleList, setRoleList] = useState([]);
  const [image, setImage] = useState({ preview: "", raw: "" });
  const [searchClient, setSearchClient] = useState("");
  const [createNew, setCreateNew] = useState({
    userType: "",
    name: "",
    clientId: "",
    email: "",
    phone: "",
    roleId: "",
    image: "",
    countryCode:""
  });
  const [Newinspector, setInspector] = useState([]);
  const [clientUrl, setClientUrl] = useState("");
  const [contractorUrl, setContractorUrl] = useState("");
  const [isLoaded, setIsLoaded] = useState(false);

  const getRoles = () => {
    axiosInstance.get("/role/")
      .then(res => {
        const arr = res?.data?.data?.map(item => ({
          value: item.roleId,
          label: item.roleName,
        })) || [];
        setRoleList(arr);
      })
      .catch(console.error);
  };

  const getUserDetails = () => {
    axiosInstance.get(`/user/user-details/${editUserId}`)
      .then((res) => {
        const data = res?.data?.data;

        setCreateNew({
          userType: data?.userType?.toString() || "",
          name: data?.name || data?.clientName || data?.teamName || data?.subName || "",
          clientId: data?.clientId || "",
          email: data?.email || "",
          phone: data?.phone?.number || "",
          roleId: data?.roleId || "",
          userImage: data?.userImage?.file || "",
          countryCode: data?.phone.countryCode,
      oldImage:  data?.userImage?.file,

        });

        if (data?.userImage?.[0]) {
          setImage({ preview: data.userImage[0], raw: "" });
        }

        setIsLoaded(true);
      })
      .catch(err => {
        console.error("Error fetching user details:", err);
        toast.open({ type: "error", message: "Failed to fetch user details" });
      });
  };

  const getContractsByClientId = () => {
    axiosInstance.get(`/team/drop-down`)
      .then((res) => {
        const formatted = res.data.map(item => ({
          value: item.value,
          label: item.label,
        })) || [];
        setInspector(formatted);
      })
      .catch(err => {
        console.error("Error fetching contracts by client ID:", err);
        setInspector([]);
      });
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validationSchema: yup.object({
      email: yup.string().required("Email is required!"),
      name: yup.string().required("Name is required!"),
    }),
    onSubmit: async (value, { resetForm }) => {
      let formData = new FormData();
      let isClient = value.clientId ? true : false;
      let newValue = { ...value, isClient };
      formData.append("json_data", JSON.stringify(newValue));
      if (image.raw) formData.append("userImage", image.raw);

      await editFormData({
        url: `/user/edit-user-details/${editUserId}`,
        formData,
        navigateUrl: from || `/settings/user`,
        resetForm,
      });
    },
  });

    const [inputKey, setInputKey] = useState(Date.now()); 
  

 const handleChangeImg = (e) => {
    if (e.target.files.length) {
      setImage({
        preview: URL.createObjectURL(e.target.files[0]),
        raw: e.target.files[0],
      });
    }
  };

  const handleImageRemove = () => {
    setImage({
      preview: "",
      raw: "",
    });
    setCreateNew((prevState) => ({ ...createNew, userImage: "" }));
    formik.values.userImage = "";
    formik.values.oldImage = "";

    setInputKey(Date.now()); 
  };

  const handleDeleteImg = () => {
    setImage({ preview: "", raw: "" });
    setCreateNew(prev => ({ ...prev, image: "" }));
    formik.setFieldValue("image", "");
  };

  useEffect(() => {
    getRoles();
    if (editUserId) {
      getUserDetails();
    }
  }, [editUserId]);

  useEffect(() => {
    if (!formik.values?.userType) return;

    if (formik.values.userType === "1") {
      setClientUrl("/clients/drop-down");
    } else {
      setClientUrl("");
    }

    if (formik.values.userType === "3") {
      setContractorUrl("/suppliers/drop-down/2");
    } else {
      setContractorUrl("");
    }
  }, [formik.values?.userType]);

  useEffect(() => {
    if (formik.values?.userType === "2") getContractsByClientId();
  }, [formik.values?.userType]);

  useEffect(() => {
    if (!formik.values?.userType) return;

    if (formik.values.userType === "1") {
      const clientRole = roleList.find(role => role.label === "Client");
      if (clientRole) formik.setFieldValue("roleId", clientRole.value);
    } else {
      formik.setFieldValue("roleId", "");
    }
  }, [formik.values?.userType, roleList]);

  const { data: client } = UseCustomerDropDownNew(clientUrl, searchClient);
  const { data: contractor } = UseCustomerDropDownNew(contractorUrl, searchClient);

  // if (!isLoaded) return <div className="p-6">Loading...</div>;

  return (
    <div className="w-full h-full px-4 py-2">
      {contextHolder}
      <div className="w-full sm:flex justify-between items-center">
        <Breadcrumb
          items={[
            { name: "Settings" },
            { name: "User", link: "/settings/user" },
            { name: "Edit" },
          ]}
        />
        <div className="flex justify-end">
          <BackButton />
        </div>
      </div>

      <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-xl overflow-hidden mt-4">
          <div className="w-full h-full flex flex-wrap py-2 px-4 overflow-y-auto">
            <SettingHeading title="Personal Info " />
              <CustomImgUpload
               key={inputKey}
                borderStyle="dashed"
                isRemove={true}
                width="w-full"
                removeFunction={handleImageRemove}
                handleChange={handleChangeImg}
                preview={image.preview || createNew.userImage || ""}
              />

            <FormikSelectTwo
              label="Type"
              placeholder="Choose"
              Options={[
                { value: "0", label: "User" },
                { value: "1", label: "Client" },
                { value: "2", label: "Team" },
                { value: "3", label: "Sub-Contractor" },
              ]}
              formik={formik}
              name="userType"
              width="w-full md:w-1/3 md:-mt-2"
            />

            {formik.values.userType === "0" && (
              <NuInput
                label="Name"
                placeholder="Enter Name"
                formik={formik}
                name="name"
                isRequired
                width="w-full md:w-1/3 md:-mt-2"
              />
            )}

            {formik.values.userType === "1" && (
              <FormikSelectTwo
                label="Client"
                placeholder="Client"
                Options={client}
                formik={formik}
                name="clientId"
                width="w-full md:w-1/3 md:-mt-2"
                setSearch={setSearchClient}
              />
            )}

            {formik.values.userType === "2" && (
              <FormikSelectTwo
                label="Team"
                placeholder="Team"
                Options={Newinspector}
                formik={formik}
                name="clientId"
                width="w-full md:w-1/3 md:-mt-2"
                onChange={selectedOption => {
                  formik.setFieldValue("clientId", selectedOption?.value || "");
                  formik.setFieldValue("name", selectedOption?.label || "");
                }}
              />
            )}

            {formik.values.userType === "3" && (
              <FormikSelectTwo
                label="Sub-Contractor"
                placeholder="Sub-Contractor"
                Options={contractor}
                formik={formik}
                name="clientId"
                width="w-full md:w-1/3 md:-mt-2"
                onChange={selectedOption => {
                  formik.setFieldValue("clientId", selectedOption?.value || "");
                  formik.setFieldValue("name", selectedOption?.label || "");
                }}
              />
            )}

            <NuInput
              type="email"
              label="Email"
              placeholder="Email"
              formik={formik}
              name="email"
              isRequired
              width="w-full md:w-1/3 md:-mt-2"
            />

          <NuMobileNumber
              nunCode="countryCode"
              label="Phone"
              placeholder="Phone"
              formik={formik}
              name="phone"
              width="w-full md:w-1/3 md:-mt-2"
              FixPosition={true}
              PortalTarget={false}
            />

            <SettingHeading title="User Role" />
            <FormikSelectTwo
              label="Role"
              placeholder="Choose"
              Options={roleList}
              formik={formik}
              name="roleId"
              width="w-full md:w-1/3 md:-mt-2"
              isRequired
            />

            <div className="w-full hidden md:block mx-auto my-4 mt-8">
              <div className="md:flex justify-end gap-4">
                <CancelButton handleClick={() => Oncancel(-1)} />
                <SubmitButton isLoading={isLoading} />
              </div>
            </div>

          </div>
        </div>
      </form>
    </div>
  );
}

export default EditUser;



